<script setup>
import { Link } from '@inertiajs/vue3';
import { IconChevronRight } from '@tabler/icons-vue';
import { Collapsible } from '@/components/ui/collapsible';

defineProps({
    item: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <li>
        <Link
            v-if="!item.children"
            :href="item.href"
            :class="[
                item.current
                    ? 'border-primary text-primary'
                    : 'border-transparent text-gray-800  hover:text-primary',
                'group flex items-center gap-x-2.5 border-l-4 px-6 py-2 text-sm font-medium leading-normal transition',
            ]"
        >
            <component
                :is="item.icon"
                :class="[
                    item.current
                        ? 'text-primary'
                        : 'text-gray-500 group-hover:text-primary',
                    'size-5 shrink-0 transition',
                ]"
                aria-hidden="true"
            />
            {{ item.name }}
        </Link>

        <Collapsible
            v-else
            :default-open="item.current"
        >
            <template #trigger="{ open }">
                <button
                    type="button"
                    :class="[item.current ? 'border-primary text-primary' : 'border-transparent text-gray-900 hover:text-primary']"
                    class="group flex w-full items-center gap-x-2.5 border-l-4 px-6 py-2 text-sm font-medium leading-normal transition cursor-pointer"
                >
                    <component
                        :is="item.icon"
                        :class="[
                            item.current
                                ? 'text-primary'
                                : 'text-gray-500 group-hover:text-primary',
                            'size-5 shrink-0 transition',
                        ]"
                        aria-hidden="true"
                    />
                    {{ item.name }}
                    <IconChevronRight
                        :class="[open ? 'rotate-90 text-gray-500' : 'text-gray-400', 'ml-auto size-5 shrink-0']"
                        aria-hidden="true"
                    />
                </button>
            </template>

            <ul class="mt-0.5 px-2">
                <li
                    v-for="subItem in item.children"
                    :key="'subitem' + subItem.name"
                >
                    <Link
                        :href="subItem.href"
                        :class="[subItem.current ? 'text-primary' : 'hover:text-black', 'block rounded-md py-1.5 pr-2 pl-13 text-sm text-gray-700 cursor-pointer transition-colors']"
                    >
                        {{ subItem.name }}
                    </Link>
                </li>
            </ul>
        </Collapsible>
    </li>
</template>
